import { SearchCostCentreFormData } from 'core/cuenta/models/SearchCostCentreFormData';
import { useCoreService } from 'core/services/useCoreService';
import { createContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatParams } from 'shared/utils';
import { CentroCostoSelectOption } from '../models/CentroCostoSelectOption';
import { COST_CENTRE_TOTALS_BY_ID_PATH } from '../routes';
import { useDataFetcher } from 'shared/http';
import { LoadingSpinner } from 'shared/spinner/components/LoadingSpinner';

interface ICostCentreSelectorContext {
  costCentreList: CentroCostoSelectOption[];
  searchCostCentreMovements: (data: SearchCostCentreFormData) => void;
}

export const CostCentreSelectorContext = createContext<ICostCentreSelectorContext>({
  costCentreList: null,
  searchCostCentreMovements: () => {},
});

export const CostCentreSelectorProvider = ({ children }) => {
  const [costCentreList, setCostCentreListRequest] = useDataFetcher<
    CentroCostoSelectOption[]
  >([]);
  const coreService = useCoreService();
  const navigate = useNavigate();

  useEffect(() => {
    const responseMapper = (list: any[], tab?: number) => {
      let spaces = '';
      if (tab) {
        spaces = '\u00A0'.repeat(tab) + generateSymbol(tab);
      } else {
        tab = 0;
      }
      let response = [];
      list.forEach((e) => {
        e['denominacion'] = spaces + e['denominacion'];
        response.push(new CentroCostoSelectOption(e));
        if (e['hijos'].length) {
          response = response.concat(responseMapper(e['hijos'], tab + 2));
        }
      });
      return response;
    };

    const generateSymbol = (c: number) => {
      const symbols = {
        0: '-',
        2: '>',
        4: '»',
        6: '*',
      };
      return symbols[c % 8];
    };

    setCostCentreListRequest(() =>
      coreService.getCostCentreList().then((response) => responseMapper(response.body)),
    );
  }, [coreService, setCostCentreListRequest]);

  const contextValue = {
    searchCostCentreMovements: (data: SearchCostCentreFormData) => {
      navigate({
        pathname: COST_CENTRE_TOTALS_BY_ID_PATH.replace(':ccId', `${data.costcentre}`),
        search: formatParams(data.selectdate),
      });
    },
    costCentreList: costCentreList.data,
  };

  return (
    <CostCentreSelectorContext.Provider value={contextValue}>
      <LoadingSpinner isLoading={costCentreList.isLoading}>
        {costCentreList.data && children}
      </LoadingSpinner>
    </CostCentreSelectorContext.Provider>
  );
};
